import classNames from 'classnames';

const PacingStatusIcon = ({ className, width = '24' }) => {
  return (
    <svg
      className={classNames('pacing-status-icon', className)}
      width={width}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.7639 8H19C19.5523 8 20 7.55228 20 7C20 6.44772 19.5523 6 19 6H15C15 6.76835 15.2889 7.46924 15.7639 8ZM13.416 8C13.1484 7.38754 13 6.7111 13 6H5C4.44772 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8H13.416ZM5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H18H5ZM5 16C4.44772 16 4 16.4477 4 17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17C20 16.4477 19.5523 16 19 16H5Z'
        fill='#1B4332'
      />
      <circle cx='18' cy='6' r='3' fill='#1B4332' />
    </svg>
  );
};

export default PacingStatusIcon;
